import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import TagManager from 'react-gtm-module';
import ErrorBoundary from './errorBoundary';
import './assets/styles/style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRouter from './routes/AppRouter';
import AppRouterMaintenance from './routes/AppRouterMaintenance';
import { pgiPath } from './helpers/constants';

const currentPath = window.location.pathname;

const tagManagerArgs = {
  gtmId: 'GTM-W44FC5T'
};

if (!currentPath.includes(pgiPath)) {
  TagManager.initialize(tagManagerArgs);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    {process.env.REACT_APP_MAINTENANCE === "true" ? <AppRouterMaintenance /> : <AppRouter />}
  </ErrorBoundary>
);




serviceWorkerRegistration.register();